const publicRoutes = [
    '/vdk-events/get-by-id',
    '/vdk-events/user-country',
    '/vdk-events/validate-password',
    '/field-responses/submit-form',
    '/vdkeventlanguages/get-all',
    '/field-responses/check-email',
    '/pickup-locations/is-closed',
    '/faq/registration/get-by-event'
];
export default publicRoutes;
